module.exports = __webpack_public_path__ + "fonts/fa-brands-400.ed311c7a.woff2";